import { render, staticRenderFns } from "./Allies.vue?vue&type=template&id=03cf6849&"
import script from "./Allies.vue?vue&type=script&lang=js&"
export * from "./Allies.vue?vue&type=script&lang=js&"
import style0 from "./Allies.vue?vue&type=style&index=0&id=03cf6849&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports